export const loaded = {};
export const loadPromises = {};
//# sourceMappingURL=memory.js.map